import { render, staticRenderFns } from "./side-nav-items.vue?vue&type=template&id=6f02f8ce&"
import script from "./side-nav-items.vue?vue&type=script&lang=js&"
export * from "./side-nav-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f02f8ce')) {
      api.createRecord('6f02f8ce', component.options)
    } else {
      api.reload('6f02f8ce', component.options)
    }
    module.hot.accept("./side-nav-items.vue?vue&type=template&id=6f02f8ce&", function () {
      api.rerender('6f02f8ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/navbar/side-nav-items.vue"
export default component.exports